module.exports = __webpack_public_path__ + "img/mile2-m@1.4b8653fb.jpg";